import { $, addAction } from '@situation/setdesign.util';

addAction(SetDesign.GFORM_CONFIRM, () => {
    $('.gform_wrapper').removeClass('loading');
    const redirect = $('.confirmation-results').data('redirect');

    setTimeout(() => {
        window.top.location.href = redirect;
    }, 1000);
});
